// === LLM_analysis_prompt.js ===

// System Prompt & Investor Profile
export const systemPrompt = `You are a professional investment advisor. 
`;

export const investorProfile = `
--- INVESTOR PROFILE ---
I am 57, living off my portfolio, aiming for stable income with moderate growth to support my kids.
No real other income. Pension starts in 10 years.
--- END OF PROFILE ---
`;

export const questionTypePrompts = {
  "Generic Advice": `
--- QUESTION TYPE PROMPT ---
Given all the context:
This is a general advice question. No extra specifics.
--- END OF QUESTION TYPE PROMPT ---
`,

  "Specific stock - General": `
--- QUESTION TYPE PROMPT ---
Given all the context:
Focus on a single stock in general, include market and fundamentals.
--- END OF QUESTION TYPE PROMPT ---
`,

  "Specific stock - My Portfolio": `
--- QUESTION TYPE PROMPT ---
Given all the context:
Focus on a single stock WITHIN MY PORTFOLIO. Prioritize personal risk, portfolio fit, and rebalancing.
--- END OF QUESTION TYPE PROMPT ---
`,

  "Specific Portfolio Alert": `
--- QUESTION TYPE PROMPT ---
Given all the context:
What do you think of this alert? Should i follow it up?
--- END OF QUESTION TYPE PROMPT ---
`,

  "Specific Favorites Alert": `
--- QUESTION TYPE PROMPT ---
Given all the context:
What do you think of this alert? Should I follow it up?
--- END OF QUESTION TYPE PROMPT ---
`,

  "Specific Opportunity Alert": `
--- QUESTION TYPE PROMPT ---
Given all the context:
What do you think of this alert? Should I follow it up?
--- END OF QUESTION TYPE PROMPT ---
`

};


export const closingPrompt = `\n
Be data-driven`;

// === Helpers ===

export const prettyLabel = (field) =>
  field.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const getPromptSection = (field) => {
  const title = prettyLabel(field) + " Context";
  return `--- ${title.toUpperCase()} ---\n{${field}}\n--- END OF ${title.toUpperCase()} ---`;
};

export const buildPrompt = (selections) => {
  const activeSections = Object.keys(selections)
    .filter((key) => selections[key])
    .map((key) => getPromptSection(key));
  return activeSections.join("\n\n") + closingPrompt;
};

export const finalizePrompt = (basePrompt, contextOptions, fieldValuesRef) => {
  let final = basePrompt;
  contextOptions.forEach((field) => {
    final = final.replace(`{${field}}`, fieldValuesRef.current[field] || "N/A");
  });
  return final;
};
export const promptTemplates = {
  quantitative: "\n\n🔢 Extra detail: Include clear percentage moves, price targets, or ratios.",
  riskFirst: "\n\n⚠️ Emphasize the top risk first, then the opportunity.",
  stepByStep: `
Follow these steps:
1. Analyze each context section separately
2. Identify conflicts/alignments between data points
3. Consider the investor profile constraints
4. Only then formulate your advice`,
    noDisclaimers: "\n\n🚫 No disclaimers or generic statements allowed.",
    concise: "\n\n✂️ Keep it concise, max 3 sentences for reasoning.",
    actionable: "\n\n✅ Ensure every recommendation is actionable and specific.",
    formatstrictly: "\n\n📋 Format strictly as:\n💡 Action: [Your clear recommendation]\n⏳ Timeframe: [Short/Long-term]\n📊 Reasoning: [Data-driven explanation, 2-3 sentences max]"
};